const NavTabButton = ({ caption, onClick, isActive, tabId }) => {
  return (
    <li className='nav-item' role='presentation'>
      <button
        className={`nav-link accessibility-text ${
          isActive(tabId) ? "active" : ""
        }`}
        type='button'
        role='tab'
        aria-selected='true'
        onClick={(e) => onClick(tabId)}
      >
        {caption}
      </button>
    </li>
  );
};

export default NavTabButton;
